// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"650":"ce980402","787":"18b9e995"}[chunkId] + ".chunk.js";
};